import { ManipulatedFormula, Ingredient } from '../services/mockData';
import { generatePDFBlob } from '../services/pdfSendService';

/**
 * Gera PDF de prescrição de fórmula manipulada
 */
export async function generateManipulatedFormulaPDF(
  formula: ManipulatedFormula,
  patientName: string,
  nutritionistName: string
): Promise<Blob> {
  const { default: jsPDF } = await import('jspdf');

  const doc = new jsPDF();
  
  // Cabeçalho
  doc.setFontSize(18);
  doc.text('PRESCRIÇÃO DE FÓRMULA MANIPULADA', 105, 20, { align: 'center' });
  
  doc.setFontSize(12);
  doc.text(`Data: ${new Date(formula.prescribedAt).toLocaleDateString('pt-BR')}`, 14, 30);
  doc.text(`Paciente: ${patientName}`, 14, 36);
  doc.text(`Prescritor: ${nutritionistName}`, 14, 42);
  
  // Nome da fórmula
  doc.setFontSize(14);
  doc.text('Fórmula:', 14, 52);
  doc.setFontSize(12);
  doc.text(formula.formulaName, 20, 58);
  
  // Ingredientes
  let yPos = 68;
  doc.setFontSize(14);
  doc.text('Ingredientes:', 14, yPos);
  yPos += 8;
  
  doc.setFontSize(11);
  formula.ingredients.forEach((ingredient, index) => {
    const ingredientText = `${index + 1}. ${ingredient.name} - ${ingredient.quantity} ${ingredient.unit}${ingredient.purpose ? ` (${ingredient.purpose})` : ''}`;
    const splitText = doc.splitTextToSize(ingredientText, 180);
    doc.text(splitText, 20, yPos);
    yPos += splitText.length * 6;
    
    if (yPos > 280) {
      doc.addPage();
      yPos = 20;
    }
  });
  
  // Posologia
  yPos += 10;
  doc.setFontSize(14);
  doc.text('Posologia:', 14, yPos);
  yPos += 8;
  doc.setFontSize(11);
  const posologyText = doc.splitTextToSize(formula.posology, 180);
  doc.text(posologyText, 20, yPos);
  yPos += posologyText.length * 6;
  
  // Informações adicionais
  yPos += 10;
  doc.setFontSize(12);
  doc.text(`Quantidade: ${formula.quantity} ${formula.unit}`, 14, yPos);
  yPos += 7;
  doc.text(`Duração: ${formula.duration} dias`, 14, yPos);
  yPos += 7;
  doc.text(`Validade: ${formula.validity} dias`, 14, yPos);
  
  if (formula.laboratory) {
    yPos += 7;
    doc.text(`Laboratório: ${formula.laboratory}`, 14, yPos);
  }
  
  if (formula.observations) {
    yPos += 10;
    doc.setFontSize(12);
    doc.text('Observações:', 14, yPos);
    yPos += 7;
    doc.setFontSize(10);
    const observationsText = doc.splitTextToSize(formula.observations, 180);
    doc.text(observationsText, 20, yPos);
  }
  
  // Rodapé
  const pageCount = doc.internal.pages.length - 1;
  doc.setFontSize(8);
  doc.text(
    `Documento gerado via NutriSync Web - Página ${pageCount}`,
    105,
    285,
    { align: 'center' }
  );
  
  return await generatePDFBlob(doc);
}

